import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {ProjectGuestMyProject} from './ProjectGuestMyProject'
import {ProjectGuestBookings} from './ProjectGuestBookings'
import {ProjectGuestBook} from './ProjectGuestBook'
import {ProjectGuestTeam} from './ProjectGuestTeam'
import {ProjectGuestProfile} from './ProjectGuestProfile'

// Nested inside ProjectGuestLayout at the /projects/guest route fork in Routes.tsx (Phase 4.1/4.4).
export function ProjectGuestRoutes() {
  return (
    <Switch>
      <Route exact path='/projects/guest' component={ProjectGuestMyProject} />
      <Route exact path='/projects/guest/bookings' component={ProjectGuestBookings} />
      <Route exact path='/projects/guest/book' component={ProjectGuestBook} />
      <Route exact path='/projects/guest/team' component={ProjectGuestTeam} />
      <Route exact path='/projects/guest/profile' component={ProjectGuestProfile} />
      <Redirect to='/projects/guest' />
    </Switch>
  )
}
